import { Columns } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Box, Typography, Arrange, Button } from "@aviary";
import { l } from "@emerson/locales/i18n";

import * as styles from "./DiscoverEmerson.styles";

const DiscoverEmerson = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography type="h2">{t(l.homepage.SectionTitles.DiscoverEmerson)}</Typography>
      <Box accentColor="forest" padding="large">
        <Columns customCss={styles.centered}>
          <Columns.Column columnWidth={4}>
            <Arrange isFullHeight justify="center" isVertical css={styles.discoverEmersonContent}>
              <Typography type="body">{t(l.homepage.common.Fullscript)}</Typography>
              <Typography type="h3">
                {t(l.homepage.subHeading.DiscoverEmersonSubHeading)}
              </Typography>
              <Typography type="body">
                {t(l.homepage.sectionContent.DiscoverEmersonContent)}
              </Typography>
              <Button href="https://fullscript.com/">{t(l.homepage.common.LearnMore)}</Button>
            </Arrange>
          </Columns.Column>
          <Columns.Column columnWidth={8}>
            <iframe
              src="https://www.youtube.com/embed/NXZ_0Ugg8Zw?si=twHHTnbU346-mVfH"
              title="Protect Your Practice"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              css={styles.video}
            />
          </Columns.Column>
        </Columns>
      </Box>
    </div>
  );
};

export { DiscoverEmerson };
